// extracted by mini-css-extract-plugin
module.exports = {"customSearch":"MegaMenu_customSearch___Czxd","faCustom":"MegaMenu_faCustom__NMzoS","itemList":"MegaMenu_itemList__2NGEU"};